// src/app/views/pages_predict/g5/rtPrG5.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const G5Verify = Loadable(lazy(() => import("./G5Verify")));
const G5Mark = Loadable(lazy(() => import("./G5Mark")));
const G5Survey = Loadable(lazy(() => import("./G5Survey")));
const G5Result = Loadable(lazy(() => import("./G5Result")));
// const G5Score = Loadable(lazy(() => import("./G5Score")));
const pathExt = getPathByCdExt(EXAM_TYPES.G5.rid_cd_ext);

const rtPbG5 = [
  { path: `/pre/${EXAM_TYPES.G5.rid_cd_ext}/verify`, element: <G5Verify /> },
  { path: `/pre/${EXAM_TYPES.G5.rid_cd_ext}/mark`, element: <G5Mark /> },
  { path: `/pre/${EXAM_TYPES.G5.rid_cd_ext}/survey`, element: <G5Survey /> },
  { path: `/pre/${EXAM_TYPES.G5.rid_cd_ext}/result`, element: <G5Result /> },
  // { path: `/pred${pathExt}/score`, element: <G5Score /> },
];
export default rtPbG5;
